/* eslint-disable max-lines */
//POST requests

import { API_BASE_URL, URL_EXTENSION } from '@utils/constants/app-constants.ts';
import {
  buildCollectionUrl,
  PagedListParams
} from '@utils/api/endpoints.paged.ts.tsx';

export const POST_URL = (
  arg1: string = '',
  arg2: string = '',
  arg3: string = ''
): {
  login: string;
  loginMfa: string;
  logout: string;
  register: string;
  forgotPassword: string;
  resetPassword: string;
  updateCustomer: string;
  setPaymentSession: string;
  paymentSessions: string;
  createWorkspace: string;
  translateDocument: string;
  createFolder: string;
  duplicateFolder: string;
  createOrganization: string;
  createSubscription: string;
  updateMe: string;
  updatePassword: string;
  updateOrganization: string;
  createTeam: string;
  createUser: string;
  createReseller: string;
  createSubscriptionPlan: string;
  resellerLanguagePublication: string;
  addMembersToTeam: string;
  createComment: string;
  resetPass: string;
  forgotPass: string;
  registerUser: string;
  copyDocument: string;
  createCustomerBo: string;
  verify2faCode: string;
  verify2faBackupCode: string;
  disable2fa: string;
  enable2fa: string;
  publication: string;
  languageAndConfigs: string;
  retry: string;
  requeueQueueItem: string;
  retryQueueItem: string;
  bulkRequeueStuck: string;
  bulkRequeueByIds: string;
  bulkRequeueByZoomIds: string;
  bulkRetryFailed: string;
  bulkCleanupCompleted: string;
  bulkCleanupDeadLetter: string;
  bulkSetPriority: string;
  sell: string;
  billing: string;
  createGroup: string;
  createUserBo: string;
  pricePlansBo: string;
  updateUserBo: string;
  updateGroupBo: string;
  createPlaneBo: string;
  manageGroupMembers: string;
  updateLogo: string;
  updateOrganizationLogo: string;
  updateLanguageConfig: string;
  createPricePlan: string;
  updatePlan: string;
  createResellerUser: string;
  createResellerToken: string;
  exportTemplates: string;
  share: string;
  activate: string;
  finalize: string;
  registerWithPayment: string;
  resetAPassword: string;
  customerWebhooks: string;
  exportBoTemplate: string;
  userPreferences: string;
  mergeDocuments: string;
  customModel: string;
  updateCustomModel: string;
  trainLanguage: string;
  resendActivationLink: string;
  resendUserActivationLink: string;
  resendUserActivationLinkIamBo: string;
  createLanguageConfigPublication: string;
  createGlossary: string;
  createAiSummary: string;
  shareEmail: string;
  summarizeDocument: string;
  requestUploadUrl: string;
  confirmUploadComplete: string;
  reportUploadFailed: string;
  startMultipartUpload: string;
  multipartPartUrls: string;
  completeMultipartUpload: string;
  abortMultipartUpload: string;
  rehydrateSession: string;
  regenerateWaveInfo: string;
  createSpeaker: string;
  bulkCreateSpeakers: string;
  switchOrganization: string;
  resellerSwitchOrganization: string;
  createTag: string;
  createTagAssignment: string;
  contributeTrainingClip: string;
  contributeTrainingFile: string;
  startConnection: string;
  finalizeConnection: string;
  testConnection: string;
  reconnectConnection: string;
  startPublishJob: string;
  cancelPublishJob: string;
} => {
  return {
    login: `${URL_EXTENSION}/auth/login`,
    loginMfa: `${URL_EXTENSION}/auth/login/mfa`,
    logout: `${URL_EXTENSION}/auth/logout`,
    register: `${URL_EXTENSION}/signup/registration`,
    forgotPassword: `${URL_EXTENSION}/customers/password-token`,
    resetPassword: `${URL_EXTENSION}/customers/password-reset`,
    updateCustomer: `${URL_EXTENSION}/customers/me`,
    setPaymentSession: `${URL_EXTENSION}/payment-session/${arg1}`,
    paymentSessions: `${URL_EXTENSION}/payments-sessions/${arg1}`,
    createWorkspace: `/workspace`,
    translateDocument: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/translate-multiple`,
    createFolder: `${URL_EXTENSION}/folders`,
    duplicateFolder: `${URL_EXTENSION}/folders/${arg1}/duplicate`,
    createOrganization: `${URL_EXTENSION}/organization/group`,
    updateMe: `${URL_EXTENSION}/account/me`,
    updatePassword: `${URL_EXTENSION}/account/password`,
    updateOrganization: `${URL_EXTENSION}/account/organization`,
    createTeam: `${URL_EXTENSION}/organization/group`,
    createUser: `${URL_EXTENSION}/organization/user`,
    createReseller: `${URL_EXTENSION}/reseller/customer`,
    createSubscriptionPlan: `${URL_EXTENSION}/reseller/plan/${arg1}/subscribe`,
    resellerLanguagePublication: `${URL_EXTENSION}/reseller/language-publications`,
    addMembersToTeam: `${URL_EXTENSION}/organization/group/${arg1}/users`,
    createComment: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/comments`,
    resetPass: `${URL_EXTENSION}/auth/resetpassword`,
    forgotPass: `${URL_EXTENSION}/auth/forgotpassword`,
    manageGroupMembers: `${URL_EXTENSION}/admin/customer/${arg1}/group/${arg2}/members`,
    registerUser: `${URL_EXTENSION}/signup/registration`,
    copyDocument: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document`,
    createCustomerBo: `${URL_EXTENSION}/admin/customer`,
    verify2faCode: `${URL_EXTENSION}/mfa/2fa/verify_totp`,
    verify2faBackupCode: `${URL_EXTENSION}/mfa/2fa/verify_backup_code`,
    disable2fa: `${URL_EXTENSION}/mfa/2fa/disable?token=${arg1}&backup_code=${arg2}`,
    enable2fa: `${URL_EXTENSION}/mfa/2fa/enable?totp_code=${arg1}`,
    publication: `${URL_EXTENSION}/admin/plan/${arg1}/reseller_publication`,
    languageAndConfigs: `${URL_EXTENSION}/admin/languageconfig`,
    retry: `${URL_EXTENSION}/admin/stranded/retry`,
    requeueQueueItem: `${URL_EXTENSION}/admin/priority-queue/${arg1}/requeue`,
    retryQueueItem: `${URL_EXTENSION}/admin/priority-queue/${arg1}/retry`,
    bulkRequeueStuck: `${URL_EXTENSION}/admin/priority-queue/bulk/requeue-stuck`,
    bulkRequeueByIds: `${URL_EXTENSION}/admin/priority-queue/bulk/requeue-by-ids`,
    bulkRequeueByZoomIds: `${URL_EXTENSION}/admin/priority-queue/bulk/requeue-by-zoom-ids`,
    bulkRetryFailed: `${URL_EXTENSION}/admin/priority-queue/bulk/retry-failed`,
    bulkCleanupCompleted: `${URL_EXTENSION}/admin/priority-queue/bulk/cleanup-completed`,
    bulkCleanupDeadLetter: `${URL_EXTENSION}/admin/priority-queue/bulk/cleanup-dead-letter`,
    bulkSetPriority: `${URL_EXTENSION}/admin/priority-queue/bulk/set-priority`,
    sell: `${URL_EXTENSION}/admin/plan/${arg1}/subscribe`,
    billing: `${URL_EXTENSION}/admin/billing`,
    createGroup: `${URL_EXTENSION}/admin/customer/${arg1}/group`,
    createUserBo: `${URL_EXTENSION}/admin/customer/${arg1}/user`,
    pricePlansBo: `${URL_EXTENSION}/admin/priceplan/${arg1}`,
    updateUserBo: `${URL_EXTENSION}/admin/customer/${arg1}/user/${arg2}`,
    updateGroupBo: `${URL_EXTENSION}/admin/customer/${arg1}/group/${arg2}`,
    createPlaneBo: `${URL_EXTENSION}/admin/plan`,
    updateLogo: `${URL_EXTENSION}/admin/customer/${arg1}/logo`,
    updateOrganizationLogo: `${URL_EXTENSION}/organization/profile/${arg1}/logo`,
    updateLanguageConfig: `${URL_EXTENSION}/admin/languageconfig/${arg1}`,
    createPricePlan: `${URL_EXTENSION}/admin/priceplan`,
    updatePlan: `${URL_EXTENSION}/admin/plan/${arg1}`,
    createResellerUser: `${URL_EXTENSION}/reseller/customer/${arg1}/logins`,
    createResellerToken: `${URL_EXTENSION}/reseller/customer/${arg1}/tokens`,
    exportTemplates: `${URL_EXTENSION}/organization/templates`,
    share: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/share`,
    shareEmail: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/share/email`,
    activate: `${URL_EXTENSION}/signup/activate`,
    finalize: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/finished_status?status=${arg3}`,
    registerWithPayment: `${URL_EXTENSION}/order_subscription/new_order`,
    resetAPassword: `${URL_EXTENSION}/reseller/customer/${arg1}/logins/${arg2}/reset`,
    createSubscription: `${URL_EXTENSION}/order_subscription/new_order`,
    customerWebhooks: `${URL_EXTENSION}/admin/customer/${arg1}/webhooks`,
    exportBoTemplate: `${URL_EXTENSION}/admin/customer/${arg1}/export_templates/${arg2}`,
    userPreferences: `${URL_EXTENSION}/user_preferences`,
    mergeDocuments: `${URL_EXTENSION}/speech-to-text/merge`,
    customModel: `${URL_EXTENSION}/custom_models`,
    updateCustomModel: `${URL_EXTENSION}/custom_models/${arg1}`,
    trainLanguage: `${URL_EXTENSION}/custom_models/${arg1}/run`,
    resendActivationLink: `${URL_EXTENSION}/reseller/customer/${arg1}/logins/${arg2}/resend-activation`,
    resendUserActivationLink: `${URL_EXTENSION}/organization/user/${arg1}/resend-activation`,
    resendUserActivationLinkIamBo: `${URL_EXTENSION}/admin/customer/${arg1}/user/${arg2}/resend-activation`,
    createLanguageConfigPublication: `${URL_EXTENSION}/admin/languageconfig/${arg1}/publications`,
    createGlossary: `${API_BASE_URL}/api/v4/glossaries`,
    createAiSummary: `${API_BASE_URL}/api/v4/summary`,
    summarizeDocument: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/export/summarize`,
    requestUploadUrl: `${URL_EXTENSION}/speech-to-text/session/${arg1}/upload-url`,
    confirmUploadComplete: `${URL_EXTENSION}/speech-to-text/session/${arg1}/upload-complete`,
    reportUploadFailed: `${URL_EXTENSION}/speech-to-text/session/${arg1}/upload-failed`,
    startMultipartUpload: `${URL_EXTENSION}/speech-to-text/session/${arg1}/multipart/start`,
    multipartPartUrls: `${URL_EXTENSION}/speech-to-text/session/${arg1}/multipart/part-urls`,
    completeMultipartUpload: `${URL_EXTENSION}/speech-to-text/session/${arg1}/multipart/complete`,
    abortMultipartUpload: `${URL_EXTENSION}/speech-to-text/session/${arg1}/multipart/abort`,
    rehydrateSession: `${URL_EXTENSION}/speech-to-text/session/${arg1}/rehydrate`,
    regenerateWaveInfo: `${URL_EXTENSION}/speech-to-text/session/${arg1}/regenerate_wave_info`,
    createSpeaker: `${URL_EXTENSION}/organization/speakers`,
    bulkCreateSpeakers: `${URL_EXTENSION}/organization/speakers/bulk`,
    switchOrganization: `${URL_EXTENSION}/admin/me/switch-organization`,
    resellerSwitchOrganization: `${URL_EXTENSION}/reseller/me/switch-organization`,
    createTag: `${URL_EXTENSION}/organization/tags`,
    createTagAssignment: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/tags`,
    contributeTrainingClip: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/training-clips`,
    contributeTrainingFile: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/training-file`,
    startConnection: `${URL_EXTENSION}/organization/connections/start`,
    finalizeConnection: `${URL_EXTENSION}/organization/connections`,
    testConnection: `${URL_EXTENSION}/organization/connections/${arg1}/test`,
    reconnectConnection: `${URL_EXTENSION}/organization/connections/${arg1}/reconnect`,
    startPublishJob: `${URL_EXTENSION}/speech-to-text/session/${arg1}/document/${arg2}/publish`,
    cancelPublishJob: `${URL_EXTENSION}/publish-jobs/${arg1}/cancel`
  };
};

//GET requests
export const GET_URL = (
  stringId: string = '',
  stringId2: string = '',
  stringId3: string = '',
  stringId4: string = '',
  stringId5: string = '',
  stringId6: string = '',
  offset?: string,
  limit?: string,
  q?: string,
  sortingQuery?: string
): {
  profile: string;
  me: string;
  customer: string;
  resellerCustomer: string;
  workspaces: string;
  session: string;
  sharedSession: string; // TODO why is sharedSession and sharedDocument?
  sharedDocument: string; // TODO why is sharedSession and sharedDocument?
  document: string;
  sessionDocuments: string;
  models: string;
  folders: string;
  groups: string;
  tokens: string;
  teams: string;
  users: string;
  organization: string;
  entitlements: string;
  subscriptions: string;
  invoices: string;
  resellers: string;
  resellerTokens: string;
  resellerTranscripts: string;
  resellerCustomers: string;
  resellerSubscriptions: string;
  reseller: string;
  resellerPlan: string;
  resellerLanguagePublications: string;
  customerUsage: string;
  teamUsers: string;
  team: string;
  mandates: string;
  subscription: string;
  customersBo: string;
  customerBo: string;
  customerBoTokens: string;
  customerBoTokenDetails: string;
  customerBoSubscriptions: string;
  customerBoSubscription: string;
  customerBoUsage: string;
  customerBoMandates: string;
  customerBoIAM: string;
  customerBoIam: string;
  customerBoGroupIAM: string;
  customerBoIamGroup: string;
  customerBoActivity: string;
  pricePlansBo: string;
  plansBo: string;
  groupsBo: string;
  billablesBo: string;
  languageAndConfigs: string;
  languageAndConfig: string;
  usageBo: string;
  strandedSessions: string;
  priorityQueue: string;
  priorityQueueSummary: string;
  priorityQueueItem: string;
  transcriptSessions: string;
  qrCode2fa: string;
  backupCodes2fa: string;
  planBo: string;
  resellerPublications: string;
  pricePlanBo: string;
  exportTemplates: string;
  exportTemplateItems: string;
  exportTemplateItem: string;
  exportTemplateItemDownload: string;
  organizationStatus: string;
  customerWebhooks: string;
  customerWebhook: string;
  exportTemplatesBo: string;
  exportTemplateBo: string;
  userPreferences: string;
  userPreference: string;
  donwloadInvoice: string;
  customerBoUsages: string;
  usageBoDetailed: string;
  customModels: string;
  customModelsList: string;
  customModelDetail: string;
  customModelDetailData: string;
  customModelDataDownload: string;
  customModelRounds: string;
  customModelDatasetExport: string;
  billingCycles: string;
  onPremOrganizations?: string;
  onPremUsageReport?: string;
  resellerAllUsers?: string;
  sttSessions?: string;
  sttSessionsProgress?: string;
  getCustomerSellPlansBo?: string;
  languageAndConfigPublication?: string;
  customersSubOrganizationsBo?: string;
  usage?: string;
  usagesBoDetailed?: string;
  glossaries?: string;
  glossary?: string;
  supportedLanguagePairs?: string;
  glossaryEntries?: string;
  resellerUsage?: string;
  resellerStatistics?: string;
  resellerReportingExport?: string;
  documentEditMeta: string;
  documentBurnIn: string;
  documentTranslations: string;
  translationQuote: string;
  speakers: string;
  speaker: string;
  resellerExceedances: string;
  adminExceedances: string;
  adminCustomerExceedances: string;
  sysopOrgAiSummaryQuota: string;
  sysopOrgAiSummaryJobs: string;
  sysopOrgPublishing: string;
  tags: string;
  tag: string;
  tagAssignments: string;
  tagAssignment: string;
  aiSummaryJob: string;
  connections: string;
  connectionPlatforms: string;
  connection: string;
  publishTargets: string;
  publishJob: string;
  documentPublishHistory: string;
} => {
  const safeOffset = offset && offset.trim() !== '' ? offset : '0';
  const safeLimit = limit && limit.trim() !== '' ? limit : '25';

  const qPart = q && q.trim() !== '' ? `&q=${encodeURIComponent(q)}` : '';
  const sortPart =
    sortingQuery && sortingQuery.trim() !== '' ? `&${sortingQuery}` : '';

  return {
    profile: `${URL_EXTENSION}/auth`,
    me: `${URL_EXTENSION}/account/me`,
    customer: `${URL_EXTENSION}/customers/me`,
    resellerCustomer: `${URL_EXTENSION}/admin/customer?offset=${stringId}&limit=${stringId2}&q=is_reseller:eq:true${stringId3.length > 0 ? `&q=${stringId3}` : ''}`,
    workspaces: `/`,
    session: `${URL_EXTENSION}/speech-to-text/session/${stringId}`,
    sharedSession: `${URL_EXTENSION}/speech-to-text/session/${stringId}/shared`,
    document: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}${stringId3 ? `?format=${stringId3}` : ''}${stringId4 ? `${stringId3 ? '&' : '?'}template_id=${stringId4}` : ''}`,
    sessionDocuments: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document`,
    documentEditMeta: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/edit-meta`,
    documentBurnIn: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/burn-in`,
    documentTranslations: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/translations`,
    translationQuote: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/translation-quote`,
    sharedDocument: `${URL_EXTENSION}/speech-to-text/session/${stringId}/shared/document/${stringId2}`,
    models: `${URL_EXTENSION}/speech-to-text/models`,
    folders: `${URL_EXTENSION}/folders?offset=${stringId}&limit=${stringId2}${
      stringId3 ? `&q=${stringId3}` : ''
    }${stringId4 ? `&${stringId4}` : ''}${
      stringId5 ? `&direction=${stringId5}` : ''
    }`,
    groups: `${URL_EXTENSION}/organization/group?limit=100&offset=0`,
    tokens: `${URL_EXTENSION}/tokens?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    teams: `${URL_EXTENSION}/organization/group?offset=${stringId}&limit=${stringId2}&${stringId3.length > 0 ? stringId3 : ''}`,
    users: `${URL_EXTENSION}/organization/user`,
    organization: `${URL_EXTENSION}/account/organization`,
    entitlements: `${URL_EXTENSION}/account/entitlements`,
    subscriptions: `${URL_EXTENSION}/subscription?offset=${stringId}&limit=${stringId2}${
      stringId3 ? `&q=${stringId3}` : ''
    }${stringId4 ? `&sort=${stringId4}` : ''}${
      stringId5 ? `&direction=${stringId5}` : ''
    }`,
    invoices: `${URL_EXTENSION}/invoices?offset=${stringId}&limit=${stringId2}${
      stringId3 ? `&q=${stringId3}` : ''
    }${stringId4 ? `&${stringId4}` : ''}${
      stringId5 ? `&direction=${stringId5}` : ''
    }`,
    resellers: `${URL_EXTENSION}/reseller/customer?offset=${stringId}&limit=${stringId2}${
      stringId3 ? `&q=${stringId3}` : ''
    }${stringId4 ? `&${stringId4}` : ''}${
      stringId5 ? `&direction=${stringId5}` : ''
    }`,
    resellerTokens: `${URL_EXTENSION}/reseller/customer/${stringId}/tokens?offset=${stringId2}&limit=${stringId3}${
      stringId4 ? `&q=${stringId4}` : ''
    }${stringId5 ? `&sort=${stringId5}` : ''}${
      stringId6 ? `&direction=${stringId6}` : ''
    }`,
    resellerTranscripts: `${URL_EXTENSION}/reseller/customer/${stringId}/transcript?offset=${stringId3}&limit=${stringId2}${
      stringId4 ? `&q=${stringId4}` : ''
    }${stringId5 ? `&${stringId5}` : ''}${
      stringId6 ? `&direction=${stringId6}` : ''
    }`,
    resellerCustomers: `${URL_EXTENSION}/reseller/customer/${stringId}/logins?offset=${stringId2}&limit=${stringId3}&${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    resellerSubscriptions: `${URL_EXTENSION}/reseller/customer/${stringId}/subscriptions?offset=${stringId2}&limit=${stringId3}&${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    reseller: `${URL_EXTENSION}/reseller/customer/${stringId}`,
    resellerPlan: `${URL_EXTENSION}/reseller/plan?offset=${stringId}&limit=${stringId2}&${stringId3.length > 0 ? `&q=${stringId3}` : ''}`,
    resellerLanguagePublications: `${URL_EXTENSION}/reseller/language-publications`,
    customerUsage: `${URL_EXTENSION}/reseller/customer/${stringId}/usage`,
    teamUsers: `${URL_EXTENSION}/organization/group/${stringId}/users?offset=${stringId2}&limit=${stringId3}`,
    team: `${URL_EXTENSION}/organization/group/${stringId}`,
    mandates: `${URL_EXTENSION}/mandates?offset=${stringId}&limit=${stringId2}`,
    subscription: `${URL_EXTENSION}/subscription/${stringId}`,
    customersBo: `${URL_EXTENSION}/admin/customer?offset=${stringId}&limit=${stringId2}${
      stringId3 ? `&q=${stringId3}` : ''
    }${stringId4 ? `&${stringId4}` : ''}${
      stringId5 ? `&direction=${stringId5}` : ''
    }`,
    customerBo: `${URL_EXTENSION}/admin/customer/${stringId}`,
    customerBoTokens: `${URL_EXTENSION}/admin/customer/${stringId}/token`,
    customerBoTokenDetails: `${URL_EXTENSION}/admin/customer/${stringId}/token?offset=${stringId2}&limit=${stringId3}${stringId4.length > 0 ? `&q=${stringId4}` : ''}${stringId5.length > 0 ? `&${stringId5}` : ''}`,
    customerBoSubscriptions: `${URL_EXTENSION}/admin/customer/${stringId}/subscription/?limit=${stringId2}&offset=${stringId3}${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    customerBoSubscription: `${URL_EXTENSION}/admin/customer/${stringId}/subscription/${stringId2}`,
    customerBoUsage: `${URL_EXTENSION}/admin/customer/${stringId}/subscription/${stringId2}/usage`,
    customerBoMandates: `${URL_EXTENSION}/admin/customer/${stringId}/mandates?limit=${stringId2}&offset=${stringId3}${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    customerBoIAM: `${URL_EXTENSION}/admin/customer/${stringId}/user?offset=${stringId}&limit=${stringId2}&${stringId3.length > 0 ? `&q=${stringId3}` : ''}`,
    customerBoGroupIAM: `${URL_EXTENSION}/admin/customer/${stringId}/group?limit=${stringId3}&offset=${stringId2}${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    customerBoIam: `${URL_EXTENSION}/admin/customer/${stringId}/user?limit=${stringId2}&offset=${stringId3}${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    customerBoIamGroup: `${URL_EXTENSION}/admin/customer/${stringId}/group/${stringId2}?offset=${stringId3}&limit=${stringId4}&${stringId5.length > 0 ? `&q=${stringId5}` : ''}`,
    customerBoActivity: `${URL_EXTENSION}/admin/customer/${stringId}/activity/stt?limit=${stringId2}&offset=${stringId3}&${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    pricePlansBo: `${URL_EXTENSION}/admin/priceplan?${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    plansBo: `${URL_EXTENSION}/admin/plan?offset=${stringId}&limit=${stringId2}${
      stringId3 ? `&q=${stringId3}` : ''
    }${stringId4 ? `&${stringId4}` : ''}${
      stringId5 ? `&direction=${stringId5}` : ''
    }`,
    planBo: `${URL_EXTENSION}/admin/plan/${stringId}`,
    groupsBo: `${URL_EXTENSION}/admin/customer/${stringId}/group/${stringId2}`,
    billablesBo: `${URL_EXTENSION}/admin/billing?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    languageAndConfigs: `${URL_EXTENSION}/admin/languageconfig?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    languageAndConfig: `${URL_EXTENSION}/admin/languageconfig/${stringId}`,
    usageBo: `${URL_EXTENSION}/admin/usage?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    transcriptSessions: `${URL_EXTENSION}/admin/usage/traffic?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    strandedSessions: `${URL_EXTENSION}/admin/stranded?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    priorityQueue: `${URL_EXTENSION}/admin/priority-queue?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    priorityQueueSummary: `${URL_EXTENSION}/admin/priority-queue/summary`,
    priorityQueueItem: `${URL_EXTENSION}/admin/priority-queue/${stringId}`,
    qrCode2fa: `${URL_EXTENSION}/mfa/2fa/qr_code`,
    backupCodes2fa: `${URL_EXTENSION}/mfa/2fa/backup_codes`,
    resellerPublications: `${URL_EXTENSION}/admin/plan/${stringId}/reseller_publication`,
    pricePlanBo: `${URL_EXTENSION}/admin/priceplan/${stringId}`,
    exportTemplates: `${URL_EXTENSION}/organization/templates`,
    exportTemplateItems: `${URL_EXTENSION}/export-template-items?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    exportTemplateItem: `${URL_EXTENSION}/export-template-items/${stringId}`,
    exportTemplateItemDownload: `${URL_EXTENSION}/export-template-items/${stringId}/download${stringId2 ? `?expiry_seconds=${stringId2}` : ''}`,
    organizationStatus: `${URL_EXTENSION}/order_subscription/status/${stringId}/${stringId2}`,
    customerWebhooks: `${URL_EXTENSION}/admin/customer/${stringId}/webhooks?limit=${stringId2}&offset=${stringId3}${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    customerWebhook: `${URL_EXTENSION}/admin/customer/${stringId}/webhooks/${stringId2}`,
    exportTemplatesBo: `${URL_EXTENSION}/admin/customer/${stringId}/export_templates?limit=${stringId2}&offset=${stringId3}${stringId4.length > 0 ? `&q=${stringId4}` : ''}`,
    exportTemplateBo: `${URL_EXTENSION}/admin/customer/${stringId}/export_templates/${stringId2}`,
    userPreferences: `${URL_EXTENSION}/user_preferences?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}`,
    userPreference: `${URL_EXTENSION}/user_preferences/${stringId}`,
    donwloadInvoice: `${URL_EXTENSION}/invoices/${stringId}/download`,
    customerBoUsages: `${URL_EXTENSION}/admin/customer/${stringId}/subscription/${stringId2}/usage?offset=${stringId4}&limit=${stringId3}&${stringId5.length > 0 ? stringId5 : ''}`,
    usageBoDetailed: `${URL_EXTENSION}/admin/usage`,
    usagesBoDetailed: `${URL_EXTENSION}/admin/usage/detailed`,
    customModels: `${URL_EXTENSION}/speech-to-text/models?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}${stringId5.length > 0 ? `&direction=${stringId5}` : ''}`,
    customModelsList: `${URL_EXTENSION}/custom_models?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}${stringId5.length > 0 ? `&direction=${stringId5}` : ''}`,
    customModelDetail: `${URL_EXTENSION}/custom_models/${stringId}`,
    customModelDetailData: `${URL_EXTENSION}/custom_models/${stringId}/data?offset=${stringId2}&limit=${stringId3}${stringId4.length > 0 ? `&q=${stringId4}` : ''}${stringId5.length > 0 ? `&${stringId5}` : ''}`,
    customModelDataDownload: `${URL_EXTENSION}/custom_models/${stringId}/data/${stringId2}/download`,
    customModelRounds: `${URL_EXTENSION}/custom_models/${stringId}/rounds`,
    customModelDatasetExport: `${URL_EXTENSION}/custom_models/${stringId}/data/export`,
    billingCycles: `${URL_EXTENSION}/admin/billing/cycles`,
    onPremOrganizations: `${URL_EXTENSION}/admin/billing/on-prem/organizations`,
    onPremUsageReport: `${URL_EXTENSION}/admin/billing/on-prem/${stringId}/report${stringId2 ? `?start_date=${stringId2}` : ''}${stringId3 ? `&end_date=${stringId3}` : ''}`,
    resellerAllUsers: `${URL_EXTENSION}/reseller/all_reseller_users?offset=${stringId}&limit=${stringId2}${
      stringId3 ? `&q=${stringId3}` : ''
    }${stringId4 ? `&${stringId4}` : ''}${
      stringId5 ? `&direction=${stringId5}` : ''
    }`,
    resellerUsage: `${API_BASE_URL}/api/v3/reseller/usage${stringId ? `?period_start=${stringId}` : ''}${stringId2 ? `&period_end=${stringId2}` : ''}`,
    resellerStatistics: `${API_BASE_URL}/api/v3/reseller/statistics${stringId ? `?period_start=${stringId}` : ''}${stringId2 ? `&period_end=${stringId2}` : ''}`,
    resellerReportingExport: `${API_BASE_URL}/api/v3/reseller/reporting/export${stringId ? `?period_start=${stringId}` : ''}${stringId2 ? `&period_end=${stringId2}` : ''}`,
    sttSessions: `${URL_EXTENSION}/speech-to-text/session?offset=${safeOffset}&limit=${safeLimit}${qPart}${sortPart}`,
    sttSessionsProgress: `${URL_EXTENSION}/speech-to-text/session/progress?offset=${safeOffset}&limit=${safeLimit}${qPart}${sortPart}`,
    getCustomerSellPlansBo: `${URL_EXTENSION}/admin/customer?offset=${stringId}&limit=${stringId2}`,
    languageAndConfigPublication: `${URL_EXTENSION}/admin/languageconfig/${stringId}/publications?offset=${stringId}&limit=${stringId2}${stringId3.length > 0 ? `&q=${stringId3}` : ''}${stringId4.length > 0 ? `&${stringId4}` : ''}`,
    customersSubOrganizationsBo: `${URL_EXTENSION}/admin/customer/${stringId}/sub-organizations?offset=${stringId2}&limit=${stringId3}${stringId4.length > 0 ? `&q=${stringId4}` : ''}${stringId5.length > 0 ? `&${stringId5}` : ''}`,
    usage: `${URL_EXTENSION}/admin/subscription/${stringId}`,
    aiSummaryJob: `${API_BASE_URL}/api/v4/summary/${stringId}`,
    glossaries: `${API_BASE_URL}/api/v4/glossaries`,
    glossary: `${API_BASE_URL}/api/v4/glossaries/${stringId}?include_entries=${stringId2 || 'false'}&limit=${stringId3 || '1000'}`,
    supportedLanguagePairs: `${API_BASE_URL}/api/v4/glossaries/supported-languages`,
    glossaryEntries: `${API_BASE_URL}/api/v4/glossaries/${stringId}/entries`,
    speakers: `${URL_EXTENSION}/organization/speakers`,
    speaker: `${URL_EXTENSION}/organization/speakers/${stringId}`,
    resellerExceedances: `${URL_EXTENSION}/reseller/exceedances`,
    adminExceedances: `${URL_EXTENSION}/admin/dashboard/exceedances`,
    adminCustomerExceedances: `${URL_EXTENSION}/admin/customer/${stringId}/exceedances`,
    sysopOrgAiSummaryQuota: `${URL_EXTENSION}/sysop/organizations/${stringId}/ai-summary`,
    sysopOrgAiSummaryJobs: `${URL_EXTENSION}/sysop/organizations/${stringId}/ai-summary/jobs`,
    sysopOrgPublishing: `${URL_EXTENSION}/sysop/organizations/${stringId}/publishing`,
    tags: `${URL_EXTENSION}/organization/tags`,
    tag: `${URL_EXTENSION}/organization/tags/${stringId}`,
    tagAssignments: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/tags`,
    tagAssignment: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/tags/${stringId3}`,
    connections: `${URL_EXTENSION}/organization/connections`,
    connectionPlatforms: `${URL_EXTENSION}/organization/connections/platforms`,
    connection: `${URL_EXTENSION}/organization/connections/${stringId}`,
    publishTargets: `${URL_EXTENSION}/organization/connections/${stringId}/targets`,
    publishJob: `${URL_EXTENSION}/publish-jobs/${stringId}`,
    documentPublishHistory: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/publish-history`
  };
};

function requirePath(name: string, path?: string): string {
  if (!path) throw new Error(`Missing endpoint for ${name}`);
  return path;
}

export const GET_URL_NEW = (params?: PagedListParams) => {
  const base = GET_URL();

  const urls = {
    sttSessions: buildCollectionUrl(
      requirePath('sttSessions', base.sttSessions),
      params
    ),
    sttSessionsProgress: buildCollectionUrl(
      requirePath('sttSessionsProgress', base.sttSessionsProgress),
      params
    ),
    users: buildCollectionUrl(requirePath('users', base.users), params),
    teams: buildCollectionUrl(requirePath('teams', base.teams), params),
    tokens: buildCollectionUrl(requirePath('tokens', base.tokens), params),
    subscriptions: buildCollectionUrl(
      requirePath('subscriptions', base.subscriptions),
      params
    ),
    usage: buildCollectionUrl(requirePath('usage', base.usage), params),
    mandates: buildCollectionUrl(
      requirePath('mandates', base.mandates),
      params
    ),
    invoices: buildCollectionUrl(
      requirePath('invoices', base.invoices),
      params
    ),
    customModels: buildCollectionUrl(
      requirePath('customModelsList', base.customModelsList),
      params
    ),
    resellers: buildCollectionUrl(
      requirePath('resellers', base.resellers),
      params
    ),
    resellerAllUsers: buildCollectionUrl(
      requirePath('resellerAllUsers', base.resellerAllUsers),
      params
    ),
    folders: (p: PagedListParams = {}) =>
      buildCollectionUrl(requirePath('folders', base.folders), {
        ...params,
        ...p
      }),
    customersBo: buildCollectionUrl(
      requirePath('customersBo', base.customersBo),
      params
    ),
    plansBo: buildCollectionUrl(requirePath('plansBo', base.plansBo), params),
    adminExceedances: buildCollectionUrl(
      requirePath('adminExceedances', base.adminExceedances),
      params
    ),
    pricePlansBo: buildCollectionUrl(
      requirePath('pricePlansBo', base.pricePlansBo),
      params
    ),
    billablesBo: buildCollectionUrl(
      requirePath('billablesBo', base.billablesBo),
      params
    ),
    billingCycles: buildCollectionUrl(
      requirePath('billingCycles', base.billingCycles),
      params
    ),
    languageAndConfigs: buildCollectionUrl(
      requirePath('languageAndConfigs', base.languageAndConfigs),
      params
    ),
    strandedSessions: buildCollectionUrl(
      requirePath('strandedSessions', base.strandedSessions),
      params
    ),
    priorityQueue: buildCollectionUrl(
      requirePath('priorityQueue', base.priorityQueue),
      params
    ),
    transcriptSessions: buildCollectionUrl(
      requirePath('transcriptSessions', base.transcriptSessions),
      params
    ),
    exportTemplateItems: buildCollectionUrl(
      requirePath('exportTemplateItems', base.exportTemplateItems),
      params
    ),
    allSubscriptions: (p: PagedListParams = {}) =>
      buildCollectionUrl(requirePath('allSubscriptions', base.subscriptions), {
        ...params,
        ...p
      }),
    speakers: buildCollectionUrl(
      requirePath('speakers', base.speakers),
      params
    ),
    tags: buildCollectionUrl(requirePath('tags', base.tags), params)
  };

  const usageById = (
    subscriptionId: string | number,
    p: PagedListParams = {}
  ) => {
    const subsBase = requirePath('subscriptions', base.subscriptions)
      .split('?')[0]
      .replace(/\/+$/, '');
    const nested = `${subsBase}/${subscriptionId}/usage`;
    return buildCollectionUrl(nested, { ...params, ...p });
  };

  const datasetsByModelId = (
    modelId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(modelId)).customModelDetailData;
    const raw = requirePath('customModelDetailData', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const resellerSubscriptionsByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).resellerSubscriptions;
    const raw = requirePath('resellerSubscriptionsBase', endpoint).split(
      '?'
    )[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const resellerTokensByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).resellerTokens;
    const raw = requirePath('resellerTokensBase', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const resellerCustomersByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).resellerCustomers;
    const raw = requirePath('resellerCustomersBase', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const resellerTranscriptsByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).resellerTranscripts;
    const raw = requirePath('resellerTranscriptsBase', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerUsageByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).customerUsage;
    const raw = requirePath('customerUsageBase', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerBoTokensByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).customerBoTokenDetails;
    const raw = requirePath('customerBoTokenDetails', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerBoSubscriptionsByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).customerBoSubscriptions;
    const raw = requirePath('customerBoSubscriptions', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerBoMandatesByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).customerBoMandates;
    const raw = requirePath('customerBoMandates', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerBoIamByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).customerBoIam;
    const raw = requirePath('customerBoIam', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerIamGroupByCustomerAndGroupId = (
    customerId: string | number,
    groupId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(
      String(customerId),
      String(groupId)
    ).customerBoIamGroup;
    const raw = requirePath('customerBoIamGroup', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const subOrganizationsByResellerId = (
    resellerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(resellerId)).customersSubOrganizationsBo;
    const raw = requirePath('customersSubOrganizationsBo', endpoint).split(
      '?'
    )[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerActivityByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).customerBoActivity;
    const raw = requirePath('customerBoActivity', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerWebhooksByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).customerWebhooks;
    const raw = requirePath('customerWebhooks', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const exportTemplatesByCustomerId = (
    customerId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(customerId)).exportTemplatesBo;
    const raw = requirePath('exportTemplatesBo', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const billablesWith = (p: PagedListParams = {}) =>
    buildCollectionUrl(requirePath('billablesBo', base.billablesBo), {
      ...params,
      ...p
    });

  const billingCyclesWith = (p: PagedListParams = {}) =>
    buildCollectionUrl(requirePath('billingCycles', base.billingCycles), {
      ...params,
      ...p
    });

  const usageWith = (p: PagedListParams = {}) =>
    buildCollectionUrl(requirePath('usagesBoDetails', base.usagesBoDetailed), {
      ...params,
      ...p
    });

  const usageLegacyWith = (p: PagedListParams = {}) =>
    buildCollectionUrl(requirePath('usageBo', base.usageBo), {
      ...params,
      ...p
    });

  const languageAndConfigPublicationByLanguageId = (
    languageId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(String(languageId)).languageAndConfigPublication;
    const raw = requirePath('languageAndConfigPublication', endpoint).split(
      '?'
    )[0];

    return buildCollectionUrl(raw, { ...params, ...p });
  };

  const customerBoUsagesByCustomerAndSubscriptionId = (
    customerId: string | number,
    subscriptionId: string | number,
    p: PagedListParams = {}
  ) => {
    const endpoint = GET_URL(
      String(customerId),
      String(subscriptionId)
    ).customerBoUsage;
    const raw = requirePath('customerBoUsages', endpoint).split('?')[0];
    return buildCollectionUrl(raw, { ...params, ...p });
  };

  return {
    ...urls,
    usageById,
    datasetsByModelId,
    resellerSubscriptionsByCustomerId,
    resellerTokensByCustomerId,
    resellerCustomersByCustomerId,
    resellerTranscriptsByCustomerId,
    customerUsageByCustomerId,
    customerBoTokensByCustomerId,
    customerBoSubscriptionsByCustomerId,
    customerBoMandatesByCustomerId,
    customerBoIamByCustomerId,
    customerIamGroupByCustomerAndGroupId,
    subOrganizationsByResellerId,
    customerActivityByCustomerId,
    customerWebhooksByCustomerId,
    exportTemplatesByCustomerId,
    billablesWith,
    billingCyclesWith,
    usageWith,
    usageLegacyWith,
    languageAndConfigPublicationByLanguageId,
    customerBoUsagesByCustomerAndSubscriptionId
  };
};

export const GET_URL_BY_ID = (
  id: string = '',
  stringId: string = '',
  stringId2: string = '',
  stringId3: string = '',
  stringId4: string = '',
  stringId5: string = ''
): {
  usages: string;
  folder: string;

  customerBoSubscription: string;
  customerUserIam: string;
  comments: string;
  user: string;
} => {
  return {
    usages: `${URL_EXTENSION}/subscription/${id}/usage?offset=${stringId}&limit=${stringId2}`,
    folder: `${URL_EXTENSION}/folders/${id}/?offset=${stringId}&limit=${stringId2}${
      stringId3 ? `&q=${stringId3}` : ''
    }${stringId4 ? `&sort=${stringId4}` : ''}${
      stringId5 ? `&direction=${stringId5}` : ''
    }`,
    customerBoSubscription: `${URL_EXTENSION}/admin/customer/${id}/subscription/${stringId}`,
    customerUserIam: `${URL_EXTENSION}/admin/customer/${id}/user/${stringId}?offset=${stringId2}&limit=${stringId3}&${stringId4.length > 0 ? stringId4 : ''}`,
    comments: `${URL_EXTENSION}/speech-to-text/session/${id}/document/${stringId}/comments`,
    user: `${URL_EXTENSION}/organization/user/${id}`
  };
};

export const DELETE_URL = (
  stringId: string = '',
  stringId2: string = '',
  stringId3: string = ''
): {
  logout: string;
  paymentSessions: string;
  deleteWorkspace: string;
  deleteFolder: string;
  deleteSession: string;
  deleteToken: string;
  deleteTeam: string;
  deleteOrganizationUser: string;
  deleteCustomer: string;
  deleteResellerCustomerLogin: string;
  removeUser: string;
  deleteSubscription: string;
  deleteComment: string;
  deleteProfileAccount: string;
  deleteOrganizationAccount: string;
  deletePublication: string;
  deleteLogo: string;
  deleteOrganizationLogo: string;
  deleteCustomerSubscription: string;
  suspendCustomerSubscription: string;
  deleteCustomerIam: string;
  deleteResellerToken: string;
  deleteExportTemplates: string;
  resellerPublication: string;
  deleteResellerLanguagePublication: string;
  groupIam: string;
  webhook: string;
  deleteExportBoTemplates: string;
  userPreference: string;
  deleteCustomModelTranscript: string;
  deleteCustomModel: string;
  deleteSttSession: string;
  deleteLanguageConfigPublication: string;
  deleteGlossary: string;
  cancelAiSummary: string;
  deleteQueueItem: string;
  bulkDeleteQueueItems: string;
  deleteCustomerBo: string;
  purgeCustomerBo: string;
  deleteSpeaker: string;
  deleteExportTemplateItem: string;
  deleteTag: string;
  deleteTagAssignment: string;
  deleteConnection: string;
} => {
  return {
    logout: `${URL_EXTENSION}/auth`,
    paymentSessions: `${URL_EXTENSION}/carts/${stringId}/payment-sessions`,
    deleteWorkspace: `/workspace/${stringId}`,
    deleteFolder: `${URL_EXTENSION}/folders/${stringId}`,
    deleteSession: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}`,
    deleteToken: `${URL_EXTENSION}/tokens/${stringId}`,
    deleteTeam: `${URL_EXTENSION}/organization/group/${stringId}`,
    deleteOrganizationUser: `${URL_EXTENSION}/organization/user/${stringId}`,
    deleteCustomer: `${URL_EXTENSION}/reseller/customer/${stringId}`,
    deleteResellerCustomerLogin: `${URL_EXTENSION}/reseller/customer/${stringId}/logins/${stringId2}`,
    removeUser: `${URL_EXTENSION}/organization/group/${stringId}/users/remove`,
    deleteSubscription: `${URL_EXTENSION}/subscription/${stringId}`,
    deleteComment: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/comments/${stringId3}`,
    deleteProfileAccount: `${URL_EXTENSION}/account`,
    deleteOrganizationAccount: `${URL_EXTENSION}/organization/profile/${stringId}`,
    deletePublication: `${URL_EXTENSION}/admin/plan/${stringId}/reseller_publication/${stringId2}`,
    deleteLogo: `${URL_EXTENSION}/admin/customer/${stringId}/logo`,
    deleteOrganizationLogo: `${URL_EXTENSION}/organization/profile/${stringId}/logo`,
    deleteCustomerSubscription: `${URL_EXTENSION}/admin/customer/${stringId}/subscription/${stringId2}`,
    suspendCustomerSubscription: `${URL_EXTENSION}/admin/customer/${stringId}/subscription/${stringId2}`,
    deleteCustomerIam: `${URL_EXTENSION}/admin/customer/${stringId}/user/${stringId2}`,
    deleteResellerToken: `${URL_EXTENSION}/reseller/customer/${stringId}/tokens/${stringId2}`,
    deleteExportTemplates: `${URL_EXTENSION}/organization/templates/${stringId}`,
    resellerPublication: `${URL_EXTENSION}/admin/plan/${stringId}/reseller_publication/${stringId2}`,
    deleteResellerLanguagePublication: `${URL_EXTENSION}/reseller/language-publications/${stringId}`,
    groupIam: `${URL_EXTENSION}/admin/customer/${stringId}/group/${stringId2}`,
    webhook: `${URL_EXTENSION}/admin/customer/${stringId}/webhooks/${stringId2}`,
    deleteExportBoTemplates: `${URL_EXTENSION}/admin/customer/${stringId}/export_templates/${stringId2}`,
    userPreference: `${URL_EXTENSION}/user_preferences/${stringId}`,
    deleteCustomModelTranscript: `${URL_EXTENSION}/custom_models/${stringId}/data/${stringId2}`,
    deleteCustomModel: `${URL_EXTENSION}/custom_models/${stringId}`,
    deleteSttSession: `${URL_EXTENSION}/speech-to-text/session/${stringId}`,
    deleteLanguageConfigPublication: `${URL_EXTENSION}/admin/languageconfig/${stringId}/publications/${stringId2}`,
    deleteGlossary: `${API_BASE_URL}/api/v4/glossaries/${stringId}`,
    cancelAiSummary: `${API_BASE_URL}/api/v4/summary/${stringId}`,
    deleteQueueItem: `${URL_EXTENSION}/admin/priority-queue/${stringId}`,
    bulkDeleteQueueItems: `${URL_EXTENSION}/admin/priority-queue/bulk/by-ids`,
    deleteCustomerBo: `${URL_EXTENSION}/admin/customer/${stringId}`,
    purgeCustomerBo: `${URL_EXTENSION}/admin/customer/${stringId}/purge`,
    deleteSpeaker: `${URL_EXTENSION}/organization/speakers/${stringId}`,
    deleteExportTemplateItem: `${URL_EXTENSION}/export-template-items/${stringId}`,
    deleteTag: `${URL_EXTENSION}/organization/tags/${stringId}`,
    deleteTagAssignment: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/tags/${stringId3}`,
    deleteConnection: `${URL_EXTENSION}/organization/connections/${stringId}`
  };
};

export const PATCH_URL = (
  stringId: string = ''
): {
  deactivateProfileAccount: string;
  updateLanguageConfigPublication: string;
  updateGlossary: string;
  updateSessionMetadata: string;
  setPriorityItem: string;
  sysopOrgAiSummaryOverride: string;
  sysopOrgPublishing: string;
} => {
  return {
    deactivateProfileAccount: `${URL_EXTENSION}/account`,
    updateLanguageConfigPublication: `${URL_EXTENSION}/admin/languageconfig/${stringId}/publications`,
    updateGlossary: `${API_BASE_URL}/api/v4/glossaries/${stringId}`,
    updateSessionMetadata: `${URL_EXTENSION}/speech-to-text/session/${stringId}`,
    setPriorityItem: `${URL_EXTENSION}/admin/priority-queue/${stringId}/priority`,
    sysopOrgAiSummaryOverride: `${URL_EXTENSION}/sysop/organizations/${stringId}/ai-summary/override`,
    sysopOrgPublishing: `${URL_EXTENSION}/sysop/organizations/${stringId}/publishing`
  };
};

export const PUT_URL = (
  stringId: string = '',
  stringId2: string = '',
  stringId3: string = ''
): {
  updateSessionDocument: string;
  updateSharedSessionDocument: string;
  updateResellerCustomer: string;
  updateTeam: string;
  clearTextDocument: string;
  clearTextSharedDocument: string;
  updateComment: string;
  deactivateResellerCustomerLogin: string;
  updateFolder: string;
  resetDocument: string;
  resetSharedDocument: string;
  updateCustomerBo: string;
  updateUserBo: string;
  updateUser: string;
  finishSharedSessionDocument: string;
  customerWebhook: string;
  exportTemplateBo: string;
  exportTemplates: string;
  userPreference: string;
  userPreferenceByKey: string;
  addCustomModelTranscript: string;
  createDataset: string;
  updateSpeaker: string;
  updateTag: string;
  updateTagAssignment: string;
  connectionSettings: string;
} => {
  return {
    updateSessionDocument: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}`,
    updateSharedSessionDocument: `${URL_EXTENSION}/speech-to-text/session/${stringId}/shared/document/${stringId2}`,
    updateResellerCustomer: `${URL_EXTENSION}/reseller/customer/${stringId}`,
    updateTeam: `${URL_EXTENSION}/organization/group/${stringId}`,
    clearTextDocument: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/clear_text`,
    clearTextSharedDocument: `${URL_EXTENSION}/speech-to-text/session/${stringId}/shared/document/${stringId2}/clear_text`,
    updateComment: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/comments/${stringId3}`,
    deactivateResellerCustomerLogin: `${URL_EXTENSION}/reseller/customer/${stringId}/logins/${stringId2}/deactivate`,
    updateFolder: `${URL_EXTENSION}/folders/${stringId}`,
    resetDocument: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/reset_to_original`,
    resetSharedDocument: `${URL_EXTENSION}/speech-to-text/session/${stringId}/shared/document/${stringId2}/reset_to_original`,
    updateCustomerBo: `${URL_EXTENSION}/admin/customer/${stringId}`,
    updateUserBo: `${URL_EXTENSION}/customer/${stringId}/user/${stringId2}`,
    updateUser: `${URL_EXTENSION}/organization/user/${stringId}`,
    finishSharedSessionDocument: `${URL_EXTENSION}/speech-to-text/session/${stringId}/shared/document/${stringId2}/finish`,
    customerWebhook: `${URL_EXTENSION}/admin/customer/${stringId}/webhooks/${stringId2}`,
    exportTemplateBo: `${URL_EXTENSION}/admin/customer/${stringId}/export_templates/${stringId2}`,
    exportTemplates: `${URL_EXTENSION}/organization/templates/${stringId}`,
    userPreference: `${URL_EXTENSION}/user_preferences/${stringId}`,
    userPreferenceByKey: `${URL_EXTENSION}/user_preferences/key/${stringId}`,
    addCustomModelTranscript: `${URL_EXTENSION}/custom_models/${stringId}/data`,
    createDataset: `${URL_EXTENSION}/custom_models/${stringId}/data`,
    updateSpeaker: `${URL_EXTENSION}/organization/speakers/${stringId}`,
    updateTag: `${URL_EXTENSION}/organization/tags/${stringId}`,
    updateTagAssignment: `${URL_EXTENSION}/speech-to-text/session/${stringId}/document/${stringId2}/tags/${stringId3}`,
    connectionSettings: `${URL_EXTENSION}/organization/connections/${stringId}/settings`
  };
};
